import { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats as F } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Camera } from "lucide-react";

const FORMATS = [F.EAN_13, F.EAN_8, F.CODE_128, F.CODE_39, F.UPC_A, F.UPC_E, F.QR_CODE, F.ITF, F.CODABAR];

const ScannerView = ({ onResult }) => {
  const ref = useRef(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    const qr = new Html5Qrcode("cam-reader", { formatsToSupport: FORMATS, verbose: false });
    ref.current = qr;
    let done = false;
    qr.start({ facingMode: "environment" }, { fps: 12, qrbox: { width: 260, height: 140 } }, (text) => {
      if (done) return;
      done = true;
      onResult(text);
    }).catch((e) => setErr("Kamera tidak dapat diakses: " + (e?.message || e)));
    return () => {
      if (qr.isScanning) qr.stop().then(() => qr.clear()).catch(() => {});
    };
  }, [onResult]);
  return (
    <div>
      <div id="cam-reader" className="w-full overflow-hidden rounded-xl bg-black min-h-[240px]" data-testid="camera-scanner-view" />
      {err && <p className="text-sm text-destructive mt-3" data-testid="camera-error">{err}</p>}
    </div>
  );
};

export const CameraScanner = ({ open, onOpenChange, onResult }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="camera-scanner-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Camera className="h-5 w-5" /> Scan Barcode via Kamera</DialogTitle>
        <DialogDescription>Arahkan kamera ke barcode produk.</DialogDescription>
      </DialogHeader>
      {open && <ScannerView onResult={(t) => { onResult(t); onOpenChange(false); }} />}
    </DialogContent>
  </Dialog>
);
